import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { RoutineService } from 'src/app/services/routine.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';

import { RoutineGroup } from 'src/app/interfaces/routine';
import { User } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user.service';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
@Component({
  selector: 'app-routine-group-form-modal',
  templateUrl: './routine-group-form-modal.component.html',
  styleUrls: ['./routine-group-form-modal.component.scss'],
})
export class RoutineGroupFormModalComponent implements OnInit {
  @ViewChild('routineGroupFormModal') routineGroupModal: ElementRef | undefined;

  @Input() editing: boolean | undefined;
  @Input() routineGroup: RoutineGroup | undefined;

  @Output() formUpdatedDb = new EventEmitter<void>();

  user: User | undefined;
  selectedUser: User | undefined;

  routineGroupForm: UntypedFormGroup;

  userExperienceLevels: any;

  constructor(
    private fb: UntypedFormBuilder,
    private toastService: ToastService,
    private routineGroupService: RoutineService,
    private storageService: StorageService,
    private userService: UserService
  ) {
    this.routineGroupForm = this.fb.group({
      name: ['', [Validators.required]],
      weeks: [8, [Validators.required]],
      userExperience: ['0', [Validators.required]],
    });

    this.userExperienceLevels = this.userService.userExperienceLevels;
  }

  ngOnInit(): void {
    this.user = this.storageService.get('staffUser');
    this.selectedUser = this.storageService.get('selectedUser');

    this.userExperience.setValue(this.selectedUser!.experience + '');

    if (this.editing) {
      this.name.setValue(this.routineGroup!.name);
      this.weeks.setValue(this.routineGroup!.weeks);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['editing']) {
      if (this.editing) {
        this.name.setValue(this.routineGroup!.name);
        this.weeks.setValue(this.routineGroup!.weeks);
      } else {
        this.name.reset();
        this.weeks.reset();
      }
    }
  }

  onSubmit() {
    this.editing ? this.updateRoutineGroup() : this.createRoutineGroup();
  }

  returnWith0(number: number) {
    return ('0' + number).slice(-2);
  }

  createRoutineGroup() {
    const routineGroup: Pick<RoutineGroup, 'name' | 'weeks'> = {
      name: this.name.value,
      weeks: parseInt(this.weeks.value),
    };

    this.routineGroupService
      .createRoutineGroup(
        routineGroup,
        this.selectedUser!.id,
        this.userExperience.value
      )
      .subscribe({
        next: () => {
          this.formUpdatedDb.emit();
          this.clearForm();
          this.toastService.success('Se creó la rutina con éxito.');
        },
        error: (_error) => {
          if (_error.error && _error.error.messageError) {
            this.toastService.alert(_error.error.messageError);
          } else {
            this.toastService.alert(
              'Ha ocurrido un error creando la routina. Si el error persiste contactarse con el soporte.'
            );
          }
        },
      });
  }

  updateRoutineGroup() {
    const routineGroup: Pick<RoutineGroup, 'name' | 'weeks' | 'id'> = {
      id: this.routineGroup!.id,
      name: this.name.value,
      weeks: parseInt(this.weeks.value),
    };

    this.routineGroupService
      .updateRoutineGroup(
        routineGroup,
        this.selectedUser!.id,
        this.userExperience.value
      )
      .subscribe({
        next: () => {
          this.formUpdatedDb.emit();
          this.clearForm();
          this.toastService.success('Se actualizo la rutina con éxito.');
        },
        error: (_error) => {
          if (_error.error && _error.error.messageError) {
            this.toastService.alert(_error.error.messageError);
          } else {
            this.toastService.alert(
              'Ha ocurrido un error actualizando la routina. Si el error persiste contactarse con el soporte.'
            );
          }
        },
      });
  }

  clearForm() {
    this.name.setValue('');
    this.weeks.setValue('');
    this.routineGroupForm.reset();
  }

  get name() {
    return this.routineGroupForm.controls['name'];
  }

  get weeks() {
    return this.routineGroupForm.controls['weeks'];
  }

  get userExperience() {
    return this.routineGroupForm.controls['userExperience'];
  }
}
